/** News UI labels the ranking service as AI, not the product name Cursor. */
export function newsUserFacingText(text: string): string {
  return text.replace(/\bCursor\b/g, 'AI');
}
